<template>
  <div class="card-mgt-page">
    <div class="global-header-wrap">
      <span v-if="!$route.query.id">{{ $t("devices.motto.title1") }}</span>
      <span v-else>编辑格言分类</span>
      <div>
        <button class="global-button-style" @click="$router.back()">
          {{ $t("commonMsg.back") }}
        </button>
        <button class="global-button-style" @click="submitForm('ruleForm')">
          {{ $t("commonMsg.save") }}
        </button>
        <button class="global-button-style" @click="toPublic('ruleForm')">
          {{ $t("commonMsg.release") }}
        </button>
      </div>
    </div>
    <el-card
      class="app-table-container"
      :body-style="{ padding: '20px' }"
      v-bar
    >
      <div class="body-wrap">
        <el-form
          label-width="120px"
          :model="poetry"
          @submit.native.prevent
          ref="ruleForm"
          :rules="rules"
        >
          <el-form-item :label="$t('devices.poetry.name')" prop="title">
            <el-input  style="width: 200px"
              v-model="poetry.title"
              class="fl"
            ></el-input>
          </el-form-item>
          <el-form-item label="语言" prop="type">
            <el-select v-model="poetry.language" placeholder="请选择" style="width: 200px">
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import language from './libs/language'

export default {
  computed: {
    ...mapGetters(["userInfo"])
  },
  data() {
    return {
      poetry: {
        title: "",
        language: language[0].value,
        publish: false
      },
      tempTitle: '',
      userFile: null,
      rules: {
        title: [
          {
            required: true,
            message: this.$t("devices.poetry.inputTitle"),
            trigger: "blur"
          }
        ]
      },
      options: language
    };
  },
  methods: {
    getMottoDetail() {
      this.$http.getMottoDetail({id: this.$route.query.id}).then(ret => {
        for (let item in this.poetry) {
          this.poetry[item] = ret.data[item];
        }
        this.tempTitle = this.poetry.title
        this.poetry.language = ret.data.language
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.$route.query.id) {
            this.edit();
          } else {
            this.create();
          }
        } else {
          return false;
        }
      });
    },

    toPublic (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          if (this.$route.query.id) {
            this.poetry.publish = true
            this.edit();
          } else {
            this.poetry.publish = true
            this.create();
          }
        } else {
          return false;
        }
      });
    },

    create() {
      this.$http.mottoEistTitle({title: this.poetry.title}).then(res => {
        if (!res.data) {
          this.$http.addMottos(this.poetry).then(res => {
            this.$router.back();
          });
        } else {
          this.elMsg(this.$t("alertMsg.existTitle"), "warning");
        }
      })
    },

    edit() {
      this.$http.mottoEistTitle({title: this.poetry.title}).then(res => {
        if (!res.data) {
          this.poetry['id'] = this.$route.query.id
          this.$http.editMotto(this.poetry).then(res => {
            this.elMsg(this.$t("alertMsg.modifySuccess"), "success");
            this.$router.back();
          })
        } else {
          if (this.tempTitle === this.poetry.title) {
            this.poetry['id'] = this.$route.query.id
            this.$http.editMotto(this.poetry).then(res => {
              this.elMsg(this.$t("alertMsg.modifySuccess"), "success");
              this.$router.back();
            })
          } else {
            this.elMsg(this.$t("alertMsg.existTitle"), "warning");
          }
        }
      })
    }
  },
  mounted() {
    if (!this.$route.query.id) return;
    this.getMottoDetail();
  }
};
</script>

<style lang="scss">
.card-mgt-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .body-wrap {
    /* height: 100%; */
    flex: 1;
    overflow: hidden;
    .el-form {
      width: 80%;
      margin: 10px auto;
      .global-button-style {
        width: 100%;
        margin: 0;
      }
      .card-mgt-fileName {
        margin-right: 10px;
      }
      .card-import-btn {
        margin-top: 10px;
      }
    }
  }
}
</style>
